import { render, staticRenderFns } from "./payFeeConfigDiscountManageList.vue?vue&type=template&id=34fb593b&scoped=true"
import script from "./payFeeConfigDiscountManageList.vue?vue&type=script&lang=js"
export * from "./payFeeConfigDiscountManageList.vue?vue&type=script&lang=js"
import style0 from "./payFeeConfigDiscountManageList.vue?vue&type=style&index=0&id=34fb593b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fb593b",
  null
  
)

export default component.exports